/**
 * Les différentes Content-Type utilisés par l'interface.
 */
export enum ContentType {
    REMOVE_CONTENT_TYPE_FROM_HEADER = "shouldHaveBeenRemovedFromHeaderByClient",  // Demande au "AuthenticationInterceptor" de supprimer la clé "Content-Type" du header
    MULTIPART_FORM_DATA = "multipart/form-data",
    APPLICATION_JSON = "application/json",
}
